// Single source of truth for the compact `[[{c,o,v,n}]]` filter encoding —
// the string sent to the backend as `complex-filter` and persisted in the URL
// by persistStateInUrl. Byte-identical output across all callers matters:
// CustomizableList seeds a restored string that the panel's mount effect
// re-encodes, and only identical strings let React bail out instead of
// firing a redundant refetch.
const encodeFilterGroups = (groups) => {
  const params = [];
  Object.values(groups || {}).forEach((group) => {
    const curr = [];
    Object.values(group.filters || {}).forEach((filter) => {
      // Treat null/undefined/empty-string as "not set" but keep falsy-but-
      // meaningful values like 0 and false. Otherwise a choice filter with
      // value 0 (e.g. action=Created) silently drops out of the query.
      const hasValue =
        filter.value !== null &&
        filter.value !== undefined &&
        filter.value !== '';
      if (filter.active && hasValue) {
        curr.push({
          c: filter.column,
          o: filter.operator,
          v: filter.value,
          n: filter.type ? 0 : 1,
        });
      }
    });
    params.push(curr);
  });
  return JSON.stringify(params);
};

export default encodeFilterGroups;
